<template>
  <div class="row" :class="{ 'damage-readonly': readonly }">
    <div class="col-lg-3 text-center">
      <motor-bike-rear-damage
        v-on:rearDamageUpdated="motorBikeRearDamageUpdated"
        :rearMainBody="motorbike.mb_rear_main_body"
        :rearRightHandlebar="motorbike.mb_rear_right_handlebar"
        :rearRightRearViewMirror="motorbike.mb_rear_right_rear_view_mirror"
        :rearLeftHandlebar="motorbike.mb_rear_left_handlebar"
        :rearLeftRearViewMirror="motorbike.mb_rear_left_rear_view_mirror"
        :rearFrontRightIndicator="motorbike.mb_rear_front_right_indicator"
        :rearFrontLeftIndicator="motorbike.mb_rear_front_left_indicator"
        :rearFuel="motorbike.mb_rear_fuel"
        :rearSeat="motorbike.mb_rear_seat"
        :rearBackWheel="motorbike.mb_rear_back_wheel"
        :rearRightIndicator="motorbike.mb_rear_right_indicator"
        :rearLeftIndicator="motorbike.mb_rear_left_indicator"
        :rearBrakeLight="motorbike.mb_rear_brake_light"
      ></motor-bike-rear-damage>
    </div>
    <div class="col-lg-6">
      <div class="row">
        <div class="col-12 text-center">
          <motor-bike-left-damage
            v-on:leftDamageUpdated="motorBikeLeftDamageUpdated"
            :leftSeat="motorbike.mb_left_seat"
            :leftRearWheel="motorbike.mb_left_rear_wheel"
            :leftRearBreakLight="motorbike.mb_left_rear_break_light"
            :leftRearRightIndicator="motorbike.mb_left_rear_right_indicator"
            :leftMainBodyEngine="motorbike.mb_left_main_body_engine"
            :leftExhaust="motorbike.mb_left_exhaust"
            :leftRearViewMirror="motorbike.mb_left_rear_view_mirror"
            :leftHandlebar="motorbike.mb_left_handlebar"
            :leftFrontWheel="motorbike.mb_left_front_wheel"
            :leftIndicatorLight="motorbike.mb_left_indicator_light"
            :leftFrontHeadLight="motorbike.mb_left_front_head_light"
          ></motor-bike-left-damage>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <motor-bike-right-damage
            v-on:rightDamageUpdated="motorBikeRightDamageUpdated"
            :rightSeat="motorbike.mb_right_seat"
            :rightRearWheel="motorbike.mb_right_rear_wheel"
            :rightRearBreakLight="motorbike.mb_right_rear_break_light"
            :rightRearRightIndicator="motorbike.mb_right_rear_right_indicator"
            :rightMainBodyEngine="motorbike.mb_right_main_body_engine"
            :rightExhaust="motorbike.mb_right_exhaust"
            :rightRearViewMirror="motorbike.mb_right_rear_view_mirror"
            :rightHandlebar="motorbike.mb_right_handlebar"
            :rightFrontWheel="motorbike.mb_right_front_wheel"
            :rightIndicatorLight="motorbike.mb_right_indicator_light"
            :rightFrontHeadLight="motorbike.mb_right_front_head_light"
          ></motor-bike-right-damage>
        </div>
      </div>
    </div>
    <div class="col-lg-3 text-center">
      <motor-bike-front-damage
        v-on:frontDamageUpdated="motorBikeFrontDamageUpdated"
        :frontHeadLamp="motorbike.mb_front_head_lamp"
        :frontLeftHandlebar="motorbike.mb_front_left_handlebar"
        :frontLeftIndicator="motorbike.mb_front_left_indicator"
        :frontLeftRearViewMirror="motorbike.mb_front_left_rear_view_mirror"
        :frontRightHandlebar="motorbike.mb_front_right_handlebar"
        :frontRightRearViewMirror="motorbike.mb_front_right_rear_view_mirror"
        :frontMainBody="motorbike.mb_front_main_body"
        :frontRightIndicator="motorbike.mb_front_right_indicator"
        :frontWheel="motorbike.mb_front_wheel"
      ></motor-bike-front-damage>
    </div>
    <div class="row" v-if="damageToggles">
      <div class="col-12 margin-t-10">
        <hr />
        <div class="row">
          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_subframe_distortion_bend_cracks"
              label="Subframe"
              v-model="motorbike.mb_subframe_distortion_bend_cracks"
              helper="Subframe Distortion / Bend / Cracks ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_frame_distortion_bend_cracks_dents"
              label="Frame"
              v-model="motorbike.mb_frame_distortion_bend_cracks_dents"
              helper="Frame Distortion / Bends / Cracks / Dents ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_fuel_tank_leaking"
              label="Fuel Tank"
              v-model="motorbike.mb_fuel_tank_leaking"
              helper="Fuel Tank leaking?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_screen_smashed"
              label="Screen"
              v-model="motorbike.mb_screen_smashed"
              helper="Screen Smashed"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_handlebars_bent_fuel_tank_contact_damaged_grips"
              label="Handlebar"
              v-model="
                motorbike.mb_handlebars_bent_fuel_tank_contact_damaged_grips
              "
              helper="Handlebars Bent / Fuel Tank Contact / Damaged Grips ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_indicators_defective_broken"
              label="Indicators"
              v-model="motorbike.mb_indicators_defective_broken"
              helper="Indicators Defective Broken ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_clutch_break_levels_bent"
              label="Clutch"
              v-model="motorbike.mb_clutch_break_levels_bent"
              helper="Clutch / Break Levels Bent ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_headlamp_defective_misaligned"
              label="Head Lamp"
              v-model="motorbike.mb_headlamp_defective_misaligned"
              helper="Headlamp Defective / Misaligned ?"
            ></toggleswitch>
          </div>
          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_fairing_nose_cone_cracked_sharp_edges_loose"
              label="Fairing / Nose Cone Cracked"
              v-model="motorbike.mb_fairing_nose_cone_cracked_sharp_edges_loose"
              helper="Fairing / Nose Cone Cracked / Sharp Edges / Loose ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_forks_suspension_bent_dented__leaking_fork_oil"
              label="Fork / Suspension"
              v-model="
                motorbike.mb_forks_suspension_bent_dented_leaking_fork_oil
              "
              helper="Forks / Suspension Bent / Dented / Leaking Fork Oil ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_break_components_damage_movement_scratches"
              label="Break"
              v-model="motorbike.mb_break_components_damage_movement_scratches"
              helper="Break Components Damage / Movement / Scratches ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_side_fairing_cracks_sharp_edges_loose"
              label="Fairing"
              v-model="motorbike.mb_side_fairing_cracks_sharp_edges_loose"
              helper="Side Fairing Cracks / Sharp Edges / Loose ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_engine_casing_cracks_dents_leaks"
              label="Engine"
              v-model="motorbike.mb_engine_casing_cracks_dents_leaks"
              helper="Engine Casing Cracks / Dents / Leaks ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_gear_levers_break_pedal_bent"
              label="Gear Levers / Break Pedal"
              v-model="motorbike.mb_gear_levers_break_pedal_bent"
              helper="Gear Levers / Break Pedal Bent ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_r_and_f_mudguards_missing_insecure_damaged"
              label="R & F Mudguards"
              v-model="motorbike.mb_r_and_f_mudguards_missing_insecure_damaged"
              helper="R & F Mudguards Missing / Insecure / Damaged ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_swing_arm_distorted_bent_cracks_dents"
              label="Swing Arm"
              v-model="motorbike.mb_swing_arm_distorted_bent_cracks_dents"
              helper="Swing Arm Distorted / Bent / Cracks / Dents?"
            ></toggleswitch>
          </div>
          <div class="col-lg-4">
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_chain_sprockets_chain_guard_serviceable"
              label="Chain / Sprockets"
              v-model="motorbike.mb_chain_sprockets_chain_guard_serviceable"
              helper="Chain / Sprockets / Chainguard Serviceable ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_spokes_missing_not_straight"
              label="Spokes"
              v-model="motorbike.mb_spokes_missing_not_straight"
              helper="Spokes Missing / Not Straight ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_wheels_insecure_cracks_not_free_misaligned"
              label="Wheels"
              v-model="motorbike.mb_wheels_insecure_cracks_not_free_misaligned"
              helper="Wheels Insecure / Cracks / Not Free / Misaligned ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_exhaust_insecure_hitting_suspension_holed_leaks"
              label="Exhaust"
              v-model="
                motorbike.mb_exhaust_insecure_hitting_suspension_holed_leaks
              "
              helper="Exhaust Insecure / Hitting Suspension / Holed /Leaks ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_foot_begs_bent"
              label="Foot Peg(s)"
              v-model="motorbike.mb_foot_begs_bent"
              helper="Foot Peg(s) Bent ?"
            ></toggleswitch>
            <toggleswitch
              :labels="true"
              label-column="col-4"
              input-column="col-8"
              name="mb_tail_light_defective_cracks_sharp_edges"
              label="Tail Light"
              v-model="motorbike.mb_tail_light_defective_cracks_sharp_edges"
              helper="Tail Light Defective / Cracks / Sharp edges ?"
            ></toggleswitch>
          </div>
        </div>
        <input-block
          v-model="motorbike.description"
          name="description"
          label="Damage Description"
          helper="Add any additional information details about the vehicle damage here"
        ></input-block>
      </div>
    </div>
  </div>
</template>
<script>
import MotorBikeRightDamage from './../Children/MotorBike/MotorBikeRightDamage';
import MotorBikeLeftDamage from './../Children/MotorBike/MotorBikeLeftDamage';
import MotorBikeFrontDamage from './../Children/MotorBike/MotorBikeFrontDamage';
import MotorBikeRearDamage from './../Children/MotorBike/MotorBikeRearDamage';

export default {
  props: {
    motorbike: {
      type: Object,
      required: true
    },
    damage: {
      type: Object
    },
    damageToggles: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  components: {
    'motor-bike-rear-damage': MotorBikeRearDamage,
    'motor-bike-right-damage': MotorBikeRightDamage,
    'motor-bike-left-damage': MotorBikeLeftDamage,
    'motor-bike-front-damage': MotorBikeFrontDamage
  },

  methods: {
    motorBikeFrontDamageUpdated(value) {
      let refined = {
        mb_front_head_lamp: value.frontHeadLamp,
        mb_front_left_handlebar: value.frontLeftHandlebar,
        mb_front_left_indicator: value.frontLeftIndicator,
        mb_front_left_rear_view_mirror: value.frontLeftRearViewMirror,
        mb_front_right_handlebar: value.frontRightHandlebar,
        mb_front_right_rear_view_mirror: value.frontRightRearViewMirror,
        mb_front_main_body: value.frontMainBody,
        mb_front_right_indicator: value.frontRightIndicator,
        mb_front_wheel: value.frontWheel
      };
      this.updateMotorbike(refined);
      this.changeHandler();
    },

    motorBikeRearDamageUpdated(value) {
      let refined = {
        mb_rear_main_body: value.rearMainBody,
        mb_rear_right_handlebar: value.rearRightHandlebar,
        mb_rear_right_rear_view_mirror: value.rearRightRearViewMirror,
        mb_rear_left_handlebar: value.rearLeftHandlebar,
        mb_rear_left_rear_view_mirror: value.rearLeftRearViewMirror,
        mb_rear_front_right_indicator: value.rearFrontRightIndicator,
        mb_rear_front_left_indicator: value.rearFrontLeftIndicator,
        mb_rear_fuel: value.rearFuel,
        mb_rear_seat: value.rearSeat,
        mb_rear_back_wheel: value.rearBackWheel,
        mb_rear_right_indicator: value.rearRightIndicator,
        mb_rear_left_indicator: value.rearLeftIndicator,
        mb_rear_brake_light: value.rearBrakeLight
      };
      this.updateMotorbike(refined);
      this.changeHandler();
    },

    motorBikeLeftDamageUpdated(value) {
      let refined = {
        mb_left_seat: value.leftSeat,
        mb_left_rear_wheel: value.leftRearWheel,
        mb_left_rear_break_light: value.leftRearBreakLight,
        mb_left_rear_right_indicator: value.leftRearRightIndicator,
        mb_left_main_body_engine: value.leftMainBodyEngine,
        mb_left_exhaust: value.leftExhaust,
        mb_left_rear_view_mirror: value.leftRearViewMirror,
        mb_left_handlebar: value.leftHandlebar,
        mb_left_front_wheel: value.leftFrontWheel,
        mb_left_indicator_light: value.leftIndicatorLight,
        mb_left_front_head_light: value.leftFrontHeadLight
      };
      this.updateMotorbike(refined);
      this.changeHandler();
    },

    motorBikeRightDamageUpdated(value) {
      let refined = {
        mb_right_seat: value.rightSeat,
        mb_right_rear_wheel: value.rightRearWheel,
        mb_right_rear_break_light: value.rightRearBreakLight,
        mb_right_rear_right_indicator: value.rightRearRightIndicator,
        mb_right_main_body_engine: value.rightMainBodyEngine,
        mb_right_exhaust: value.rightExhaust,
        mb_right_rear_view_mirror: value.rightRearViewMirror,
        mb_right_handlebar: value.rightHandlebar,
        mb_right_front_wheel: value.rightFrontWheel,
        mb_right_indicator_light: value.rightIndicatorLight,
        mb_right_front_head_light: value.rightFrontHeadLight
      };
      this.updateMotorbike(refined);
      this.changeHandler();
    },

    updateMotorbike(data) {
      setTimeout(() => {
        for (let property in data) {
          if (Object.hasOwn(this.motorbike, property)) {
            this.motorbike[property] = data[property];
          }
        }
      }, 100);
    },

    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    }
  },

  watch: {
    damage: {
      handler(damage) {
        if (damage) {
          this.updateMotorbike(damage);
        }
      },
      immediate: true
    }
  }
};
</script>

<style>
.damage-readonly svg {
  pointer-events: none;
}
</style>
